import { Link } from 'react-router-dom';
import { Menu } from 'lucide-react';
import { useTheme } from '../../contexts/ThemeContext';
import { useSidebar } from '../../hooks/useSidebar';

const NavHeader = () => {
    const { toggleSidebar, isOpen } = useSidebar();
    const { autoHideHeader } = useTheme();

    return (
        <div className={`nav-header ${autoHideHeader ? 'auto-hide-nav-header' : ''}`}>
            <Link to="/" className="brand-logo">
                <img
                    className="logo-abbr"
                    src="/icons/logo_orion.svg"
                    alt="logo"
                    width="32"
                    height="32"
                    style={{
                        transition: 'all 0.3s ease',
                        objectFit: 'contain',
                        flexShrink: 0,
                        display: 'block'
                    }}
                />
                <img
                    className="brand-title"
                    src="/icons/logo_orion_1.svg"
                    alt="brand"
                    width="115"
                    height="28"
                    style={{
                        transition: 'all 0.3s ease',
                        marginLeft: '8px',
                        objectFit: 'contain',
                        flexShrink: 0,
                        display: 'block'
                    }}
                />
            </Link>
            <div className="nav-control" onClick={toggleSidebar} role="button" aria-label="Toggle Sidebar">
                <Menu size={18} strokeWidth={2.2} />
            </div>
        </div>
    );
};

export default NavHeader;
